// A row as a Dynamic App reads it: every cell the viewer may see, each lookup with the cells its
// targets' chains end at. Rows are always read whole, so one selection serves every read.
const APP_TABLE_ROW_FIELDS = `fragment AppTableRowFields on AppTableRow {
  id
  createdAt
  updatedAt
  createdBy
  updatedBy
  parentRowId
  cells { id at value display targets { rowId cells { id at value display } } }
}`

/**
 * The GraphQL documents an App's row reads run, by operation name. The frame names one and sends
 * its variables; the host runs its own copy, so a frame never sends a document.
 */
export const APP_GRAPHQL_DOCUMENTS = {
  AppTableRows: `query AppTableRows($input: AppTableRowsInput!) {
  appTableRows(input: $input) {
    rows { ...AppTableRowFields } select { as field } hasNext totalCount
  }
}
${APP_TABLE_ROW_FIELDS}`,
  AppTableRowCount: `query AppTableRowCount($input: AppTableRowsInput!) {
  appTableRows(input: $input) { totalCount }
}`,
  AppTableDistinct: `query AppTableDistinct($input: AppTableDistinctInput!) {
  appTableDistinct(input: $input) { values { value display rowCount } truncated }
}`,
} as const

export type AppGraphqlOperation = keyof typeof APP_GRAPHQL_DOCUMENTS

/**
 * The GraphQL subscriptions an App's rows follow, by operation name. Like the read documents, the
 * frame names one and the host runs its own copy. They stay open, so they travel on their own
 * messages rather than as reads.
 */
export const APP_GRAPHQL_SUBSCRIPTIONS = {
  UpdatedAppTableRow: `subscription UpdatedAppTableRow($input: AppTableRowSubscriptionInput!) {
  updatedAppTableRow(input: $input) { ...AppTableRowFields }
}
${APP_TABLE_ROW_FIELDS}`,
  PushAppTableRow: `subscription PushAppTableRow($input: AppTableSubscriptionInput!) {
  pushAppTableRow(input: $input)
}`,
  DeletedAppTableRow: `subscription DeletedAppTableRow($input: AppTableSubscriptionInput!) {
  deletedAppTableRow(input: $input)
}`,
} as const

export type AppGraphqlSubscription = keyof typeof APP_GRAPHQL_SUBSCRIPTIONS
